import React from 'react';
import { FadeIn, Button } from './Shared';
import { Gift, ShoppingCart } from 'lucide-react';
export const BonusesTable = () => {
  const bonuses = [{
    num: '01',
    name: 'Mapa Rápido de Rutinas por Edad',
    value: '$8.000'
  }, {
    num: '02',
    name: 'Checklist Nocturno Anti-Caos',
    value: '$8.000'
  }, {
    num: '03',
    name: 'Guía Express de Señales de Cansancio Real',
    value: '$9.000'
  }, {
    num: '04',
    name: 'Planilla de Seguimiento 7 Días',
    value: '$8.000'
  }, {
    num: '05',
    name: 'Mini Guía de Noches Difíciles Sin Improvisar',
    value: '$9.000'
  }];
  return <section className="py-6 md:py-10 px-4 bg-navy-900 text-white" data-id="element-15">
      <div className="max-w-4xl mx-auto" data-id="element-16">
        <FadeIn data-id="element-17">
          <div className="text-center mb-10" data-id="element-18">
            <h2 className="text-2xl md:text-3xl font-serif font-bold flex items-center justify-center" data-id="element-19">
              <Gift className="w-8 h-8 text-gold-400 mr-4 shrink-0" data-id="element-20" />
              🎁 5 BONOS INCLUIDOS — SIEMPRE GRATIS
            </h2>
          </div>

          <div className="space-y-4 mb-8" data-id="element-21">
            {bonuses.map((bono, index) => <div key={index} className="bg-navy-800 rounded-2xl border border-navy-700 p-5 flex flex-col sm:flex-row sm:items-center justify-between gap-4 hover:border-gold-500/30 transition-all shadow-xl group" data-id="element-22">
                <div className="flex items-center gap-4" data-id="element-23">
                  <span className="text-2xl font-bold text-gold-500/50 font-serif" data-id="element-24">
                    {bono.num}
                  </span>
                  <h3 className="text-lg font-medium text-gray-100 leading-tight" data-id="element-25">
                    {bono.name}
                  </h3>
                </div>
                <div className="flex items-center justify-between sm:justify-end gap-4 sm:shrink-0" data-id="element-26">
                  <div className="flex items-center gap-3" data-id="element-27">
                    <span className="text-gray-500 line-through text-sm" data-id="element-28">
                      {bono.value}
                    </span>
                    <span className="text-green-400 font-bold bg-green-400/10 px-3 py-1 rounded-full text-sm border border-green-400/20" data-id="element-29">
                      GRATIS
                    </span>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="bg-navy-800/50 rounded-2xl border-2 border-gold-500/30 p-6 md:p-8 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-30">
            <div className="text-center md:text-left" data-id="element-31">
              <p className="text-gray-400 uppercase tracking-widest text-sm font-bold mb-1" data-id="element-32">
                VALOR TOTAL DE LOS BONOS
              </p>
              <h4 className="text-2xl md:text-3xl font-serif font-bold text-white" data-id="element-33">
                Todo esto es tuyo sin costo extra
              </h4>
            </div>
            <div className="text-center md:text-right" data-id="element-34">
              <span className="text-gray-500 line-through text-xl block mb-1" data-id="element-35">
                $42.000
              </span>
              <span className="text-green-400 font-bold text-4xl md:text-5xl" data-id="element-36">
                GRATIS
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};